var React = require('react');

function MagnifyingGlassInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.58 26.798c6.949 0 12.581-5.632 12.581-12.58 0-6.949-5.632-12.581-12.58-12.581S1 7.269 1 14.217c0 6.949 5.633 12.581 12.58 12.581ZM22.385 23.02l3.776 3.777M28.048 24.92l-3.771 3.771 11.945 11.946 3.771-3.771L28.048 24.92Z","stroke":"#00BDC8","strokeWidth":"2","strokeMiterlimit":"10"}));
}

MagnifyingGlassInline.defaultProps = {"width":"42","height":"43","fill":"none"};

module.exports = MagnifyingGlassInline;

MagnifyingGlassInline.default = MagnifyingGlassInline;
